import { media } from 'designsystem/index';
import Arrow from 'blocks/Arrow/Arrow';
import { keyframes } from 'styled-components';

const activeAnimation = keyframes`
  0% {
    transform: scale(0.95) translateX(-3px) rotate(-45deg);
  }

  50% {
    transform: scale(1.05) translateX(2px) rotate(-45deg);
  }
  
  100% {
    transform:  scale(0.95) translateX(-3px) rotate(-45deg);
  }
`;

const ArrowRight = Arrow.extend`
  position: absolute;

  transition: left 0.25s;
  transform: rotate(-45deg);
  left: 12px;
  margin-left: 0;
  animation: ${({ animate }) => (animate ? `${activeAnimation} 1.75s ease-in-out infinite` : 'none')};
  
  ${media.desktop`
    left: -2px;
    transform: rotate(-45deg);
    margin-left: 28px;
  `};
`;

export default ArrowRight;



// WEBPACK FOOTER //
// ./src/blocks/SliderButtons/ArrowRight.jsx